export default __webpack_public_path__ + "static/media/risky.af5dff41.svg";